export default __webpack_public_path__ + "static/media/travaux_voies.d952cae7.jpg";